import React, { useEffect, useState } from "react";
import { Navbar, Container, Nav, Offcanvas } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Assets/images/logo.svg";

const MainMenu = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeOffcanvas = () => setShowOffcanvas(false);

  return (
    <Navbar expand="lg" className={`main-menu ${isSticky ? "sticky" : ""}`}>
      <Container>
        <Link to="/" className="navbar-brand py-0">
          <img src={Logo} alt="WBC Solutions" />
        </Link>
        <Navbar.Toggle
          aria-controls="offcanvasNavbar-expand-lg"
          onClick={() => setShowOffcanvas((prev) => !prev)}
        />
        <Navbar.Offcanvas
          id="offcanvasNavbar-expand-lg"
          show={showOffcanvas}
          onHide={closeOffcanvas}
          aria-labelledby="offcanvasNavbarLabel-expand-lg"
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
              <img src={Logo} alt="WBC Solutions" height={40} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="main-menu-list justify-content-center align-items-center flex-grow-1 pe-3">
              {menuData.map((item) => (
                <NavLink key={item.url} to={item.url} className="nav-link" onClick={closeOffcanvas}>
                  {item.text}
                </NavLink>
              ))}
            </Nav>
            <div className="d-flex align-items-center mt-3 mt-lg-0 justify-content-center gap-3">
              <Link to="/knowledge-catalog" className="btn-nav primary-border-btn fs-18 fw-semibold br-10" onClick={closeOffcanvas}>
                FAQ dirigeants
              </Link>
              <Link to="/contact" className="btn-nav primary-btn fs-18 fw-semibold br-10" onClick={closeOffcanvas}>
                Audit initial
              </Link>
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export const menuData = [
  { text: "Accueil", url: "/" },
  { text: "Services", url: "/services" },
  { text: "Méthode & FAQ", url: "/knowledge-catalog" },
  { text: "À propos", url: "/about" },
  { text: "Vision", url: "/out-vision" },
  { text: "Contact", url: "/contact" },
];

export default MainMenu;